<template>
  <modal
    title="Import KPA"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <h3 class="font-medium my-2">Import KPAs from existing functions.</h3>
    <p>Select a function to see existing KPAs</p>
    <el-select v-model="selectedFunction" class="my-2" placeholder="Select">
      <el-option
        v-for="function_ in functions"
        :key="function_.id"
        :label="function_.name"
        :value="function_"
      >
      </el-option>
    </el-select>
    <hr class="my-2" />
    <p class="text-xl my-2">
      Select the KPAs that are applicable to the new function you are creating.
    </p>
    <p>{{selectedKPIs.length}} selected</p>
    <div class="flex flex-col gap-2">
      <base-checkbox
        v-for="kpi in selectedFunction.kpis"
        :key="kpi.id"
        :label="kpi.name"
        :value="kpi.name"
        v-model="selectedKPIs"
      />
    </div>
    <br>
    <br>
    <br>
    <div class="flex flex-col my-2 gap-2" v-if="selectedFunction.length"> 
      <empty-kpi-icon /> 
      <p class="text-sm text-center">You have not created any functions or added any KPAs to any previous functions yet</p>
    </div>

    <div class="button-wrapper mt-5">
      <primary-button buttonText="Import KPA" @click="importKPA" v-if="selectedKPIs.length > 0"/>
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Cancel</p>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
      selectedFunction: "",
      selectedKPIs: [],
      functions: [],
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    editFunction() {
      localStorage.setItem(
        "functionToEdit",
        JSON.stringify(this.selectedFunction)
      );
      this.$router.push({ name: "EditFunction" });
    },
    async getAllFunctions() {
      this.loading = true;
      try {
        let response = await this.$_getAllFunctions();
        this.functions = response.data.functions;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    importKPA() {
      this.$emit("import-kpis", this.selectedKPIs);
      this.closeModal();
    },
  },
  mounted() {
    this.getAllFunctions();
  },
};
</script>

<style scoped>
.row {
  padding-top: 1rem !important;
}
.kpa-summary {
  margin-top: 1rem;
}
.text-grey {
  color: #7a90a7;
}
li {
  list-style-type: initial !important;
  margin-left: 1rem;
  padding-top: 0.5rem;
}
</style>
